(function () {
  const FREE_CAP_VARIANT_ID = 53752379080815;
  const FREE_SOCK_VARIANT_ID = 53753510953071;
  const CUSTOMIZATION_VARIANT_ID = 53071535898735;

  const GIFT_VARIANT_IDS = [
    FREE_CAP_VARIANT_ID,
    FREE_SOCK_VARIANT_ID
  ];

  const EXCLUDED_VARIANT_IDS = [
    ...GIFT_VARIANT_IDS,
    CUSTOMIZATION_VARIANT_ID
  ];

  let isSyncingGift = false;
  let checkTimer = null;

  async function fetchCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    return response.json();
  }

  function getEligibleQuantity(cart) {
    return cart.items.reduce((total, item) => {
      const variantId = Number(item.variant_id);

      if (EXCLUDED_VARIANT_IDS.includes(variantId)) {
        return total;
      }

      return total + item.quantity;
    }, 0);
  }

  function getDesiredGiftVariantId(eligibleQuantity) {
    if (eligibleQuantity >= 3) {
      return FREE_CAP_VARIANT_ID;
    }

    if (eligibleQuantity === 2) {
      return FREE_SOCK_VARIANT_ID;
    }

    return null;
  }

  function getGiftItems(cart) {
    return cart.items.filter((item) => {
      return GIFT_VARIANT_IDS.includes(Number(item.variant_id));
    });
  }

  function getSectionsToRender() {
    const sectionIds = new Set();

    document.querySelectorAll('[data-section-id]').forEach((el) => {
      const sectionId = el.dataset.sectionId;
      if (sectionId) {
        sectionIds.add(sectionId);
      }
    });

    return Array.from(sectionIds);
  }

  function dispatchCartUpdate(cartResponse) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartResponse,
          sourceId: 'arteeq-free-gift',
          data: {
            itemCount: cartResponse.item_count,
            source: 'arteeq-free-gift',
            sections: cartResponse.sections || {}
          }
        }
      })
    );
  }

  async function addGift(variantId) {
    const sections = getSectionsToRender();

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ],
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      throw new Error('Failed to add free gift');
    }

    return response.json();
  }

  async function updateGiftItems(updates) {
    const sections = getSectionsToRender();

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        updates,
        sections: sections.join(','),
        sections_url: window.location.pathname
      })
    });

    if (!response.ok) {
      throw new Error('Failed to update free gifts');
    }

    return response.json();
  }

  async function syncFreeGift() {
    if (isSyncingGift) return;
    isSyncingGift = true;

    try {
      const cart = await fetchCart();

      const eligibleQuantity = getEligibleQuantity(cart);
      const desiredGiftVariantId = getDesiredGiftVariantId(eligibleQuantity);
      const giftItems = getGiftItems(cart);

      const desiredGiftItem = giftItems.find((item) => {
        return Number(item.variant_id) === desiredGiftVariantId;
      });

      const wrongGiftItems = giftItems.filter((item) => {
        return Number(item.variant_id) !== desiredGiftVariantId;
      });

      console.log('[Arteeq Free Gift] Cart check:', {
        eligibleQuantity,
        desiredGiftVariantId,
        currentGifts: giftItems.map((item) => ({
          title: item.product_title,
          variantId: item.variant_id,
          quantity: item.quantity
        })),
        totalCartItems: cart.item_count
      });

      const updates = {};

      // Case 1: cart has less than 2 eligible T-shirts, remove all gifts
      if (!desiredGiftVariantId) {
        giftItems.forEach((item) => {
          updates[item.key] = 0;
        });

        if (Object.keys(updates).length > 0) {
          console.log('[Arteeq Free Gift] Removing all free gifts...');
          const updatedCart = await updateGiftItems(updates);
          dispatchCartUpdate(updatedCart);
        }

        return;
      }

      // Case 2: remove wrong gift tier
      wrongGiftItems.forEach((item) => {
        updates[item.key] = 0;
      });

      // Case 3: correct gift exists but quantity is not 1
      if (desiredGiftItem && desiredGiftItem.quantity !== 1) {
        updates[desiredGiftItem.key] = 1;
      }

      // First clean up wrong gift / wrong quantity
      if (Object.keys(updates).length > 0) {
        console.log('[Arteeq Free Gift] Fixing gift items...', updates);
        const updatedCart = await updateGiftItems(updates);

        // If correct gift already existed, we are done
        if (desiredGiftItem) {
          dispatchCartUpdate(updatedCart);
          return;
        }
      }

      // Case 4: correct gift is missing, add it
      if (!desiredGiftItem) {
        console.log('[Arteeq Free Gift] Adding correct free gift...');
        const updatedCart = await addGift(desiredGiftVariantId);
        dispatchCartUpdate(updatedCart);
        return;
      }
    } catch (error) {
      console.error('[Arteeq Free Gift] Error:', error);
    } finally {
      isSyncingGift = false;
    }
  }

  function scheduleGiftSync() {
    clearTimeout(checkTimer);

    checkTimer = setTimeout(() => {
      syncFreeGift();
    }, 400);
  }

  document.addEventListener('DOMContentLoaded', scheduleGiftSync);
  document.addEventListener('cart:update', scheduleGiftSync);
})();